module.exports = __webpack_public_path__ + "7ad1635f6a2e05857a9f1f07111432b9.svg";